 /* UrlObject
  * .parse(url) takes a url abd returns an object.
  * Object contains base path and and divides all querystring parameter key/value pairs.
  * Adding key/value parameter with setParameter and convert back to string with .toString()
  */

define(() => {
 /* REGEXP regexUrlToObject description
  * Matches either first part, or the second part with two groups.
  * If first group match found, which is the base url, the second part is left out.
  * Consecutive matches will match the second part, setting the two other groups with a param/value pair.
  * Unfamiliar with regex or lacking description? > Paste expression into something like https://regex101.com/
  *
  * Example url: /base/url?param1=value1&param2=value2
  *
  * FIRST PART
  * (^[^?]+) : ^ Start at beginning of string
  *            [^?]+ Match everything but ? once or more
  *            RESULT: /base/url
  * SECOND PART
  * [?&]{1}([^?&=]+)=([^?&]+) :
  *             [?&]{1} Match ? or & once (beginning of param/value pair)
  *             FIRST GROUP ([^?&=]+): Match everything but ?&= once or more
  *                                    RESULT: param1 (param2 second match)
  *             = match literal once to split param/value pair
  *             SECOND GROUP ([^&]+): Match everything but & once or more
  *                                   RESULT: value1 (value2 second match)
  */
  const regexUrlToObject = new RegExp('(^[^?]+)|[?&]{1}([^?&=]+)=([^&]+)', 'g');

  function toString() {
    url = this.url.base || '';
    this.url.param.length ? url + '?' : url;

    for (var i = 0; i < Object.keys(this.url.param).length; i++) {
      if (i === 0) {
        url += '?';
      }
      else if (i < Object.keys(this.url.param).length) {
        url += '&';
      }
      url += Object.keys(this.url.param)[i] + '=' + this.url.param[Object.keys(this.url.param)[i]];
    }
    return url;
  }

  function setParameter(key, value, encode) {
    if (encode) {
      key = encodeURIComponent(key);
      value = encodeURIComponent(value);
    }
    this.url.param[key] = value;
  }

  return {
    parse: function(url) {
      let urlObject = {
        toString: toString,
        setParameter: setParameter,
        url: {
          base: '',
          param: {},
        }
      };
      let match;

      while (match = this.regexUrlToObject.exec(url)) {
        if (match[1]) {
          urlObject.url.base = match[1];
          continue;
        }

        if (match[2] && match[3]) {
          urlObject.url.param[match[2]] = match[3];
        }
      }

      return urlObject;
    },
    regexUrlToObject: regexUrlToObject,
  };
});
